import React, { useState, useEffect } from "react";
import { auth, db } from "./firebase";
import {
  doc,
  updateDoc
} from "firebase/firestore";
import {
  updateProfile,
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider
} from "firebase/auth";
import "./Profile.css";

const Profile = ({ userData }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    company: "",
    country: "",
  });

  const [newPassword, setNewPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState(""); // for reauth

  useEffect(() => {
    if (userData) {
      setFormData({
        fullName: userData.fullName || auth.currentUser?.displayName || "",
        email: userData.email || auth.currentUser?.email || "",
        phone: userData.phone || "",
        company: userData.company || "",
        country: userData.country || "",
      });
    }
  }, [userData]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ✅ Toast function
  const showToast = (message, type = "success") => {
    const container = document.getElementById("toast-container");
    if (!container) return;

    const toast = document.createElement("div");
    toast.classList.add("toast");
    toast.textContent = message;

    if (type === "error") toast.style.background = "#ef4444"; // red
    else if (type === "info") toast.style.background = "#3b82f6"; // blue

    container.appendChild(toast);

    setTimeout(() => {
      toast.remove();
    }, 6000);
  };

  const handleSave = async () => {
    try {
      const user = auth.currentUser;
      if (!user) return;

      // 1️⃣ Update Firestore (non-sensitive fields)
      await updateDoc(doc(db, "users", user.uid), {
        fullName: formData.fullName,
        phone: formData.phone,
        company: formData.company,
        country: formData.country,
      });

      // 2️⃣ Update Auth display name
      await updateProfile(user, {
        displayName: formData.fullName,
      });

      // 3️⃣ If password update requested
      if (newPassword) {
        if (!currentPassword) {
          showToast("Please enter your current password to update 🔐", "error");
          return;
        }

        const credential = EmailAuthProvider.credential(
          user.email,
          currentPassword
        );
        await reauthenticateWithCredential(user, credential);

        await updatePassword(user, newPassword);
        setNewPassword("");
        setCurrentPassword("");
        showToast("Profile & Password updated successfully 🔐", "success");
      } else {
        showToast("Profile updated successfully 🚀", "success");
      }
    } catch (error) {
      console.error(error);
      if (error.code === "auth/wrong-password") {
        showToast("Current password is incorrect ❌", "error");
      } else {
        showToast("Error updating profile ❌", "error");
      }
    }
  };

  return (
    <div className="profile-container">
      {/* Toast container */}
      <div id="toast-container"></div>

      <div className="profile-card">
        {/* LEFT SIDE */}
        <div className="profile-left">
          <div className="profile-avatar">
            {formData.fullName?.charAt(0).toUpperCase() || "U"}
          </div>
          <h2>{formData.fullName || "Your Name"}</h2>
          <p>{formData.email}</p>

          <div className="verified-badge">
            <span className="tick">✔</span>
            Verified Account
          </div>

          <div className="plan-badge">{userData?.hosting || "Standard"} Plan</div>
        </div>

        {/* RIGHT SIDE */}
        <div className="profile-right">
          <h3>Personal Information</h3>

          <div className="form-grid">
            <div className="form-group">
              <label>Full Name</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                disabled
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input type="email" value={formData.email} disabled />
            </div>
            

            <div className="form-group">
              <label>Phone</label>
              <input
                type="text"
                name="phone"
                placeholder="Enter Number"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Company</label>
              <input
                type="text"
                name="company"
                placeholder="Enter Company"
                value={formData.company}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Current Password</label>
              <input
                type="password"
                placeholder="Enter current password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>New Password</label>
              <input
                type="password"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </div>
          </div>

          <button className="save-btn" onClick={handleSave}>
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;